/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import css from 'classnames';

import styles from './styles.module.scss';

export interface FluidPreloaderProps {
  className?: string | null;
  style?: React.CSSProperties;
  light?: boolean;
}

export const FluidPreloader = ({ className = null, style = undefined, light = false }: FluidPreloaderProps) => (
  <div className={css(styles.preloader, light && styles.preloaderLight, className)} style={style} />
);
